import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Navigation from '../components/Navigation';
import Teleprompter from '../components/Teleprompter';
import SettingsPage from './SettingsPage';
import { Route, Routes } from 'react-router-dom';
const DemoSyncModePage: React.FC = () => {
  const navigate = useNavigate();
  const [isScrolling, setIsScrolling] = useState(false);
  const [scrollSpeed, setScrollSpeed] = useState(2);
  const [fontSize, setFontSize] = useState(24);
  const [highlightColor, setHighlightColor] = useState('rgba(2, 25, 128, 0.2)');
  const [syncModeSettings, setSyncModeSettings] = useState({
    fontSize: 24
  });
  const [currentScript, setCurrentScript] = useState('This is a sample script in SYNC MODE. This device is now connected to the controller device. The text will scroll automatically when the controller starts scrolling.');
  const toggleScrolling = () => {
    setIsScrolling(!isScrolling);
  };
  // This function updates the temporary sync mode settings
  const updateSyncModeSettings = (newFontSize: number) => {
    setSyncModeSettings({
      ...syncModeSettings,
      fontSize: newFontSize
    });
  };
  return <div className="flex flex-col h-screen w-full bg-black text-[#51a7fa]" data-id="element-202">
      <Routes data-id="element-203">
        <Route path="/" element={<>
              <PageHeader title="Sync Mode" leftContent={null} rightContent={null} showBackButton={false} data-id="element-205" />
              <div className="flex-1 flex flex-col relative overflow-hidden" data-id="element-206">
                <Teleprompter script={currentScript} isScrolling={isScrolling} scrollSpeed={scrollSpeed} fontSize={syncModeSettings.fontSize} toggleScrolling={toggleScrolling} highlightColor={highlightColor} data-id="element-207" />
              </div>
            </>} data-id="element-204" />
        <Route path="/settings" element={<SettingsPage fontSize={syncModeSettings.fontSize} setFontSize={updateSyncModeSettings} inSyncMode={true} highlightColor={highlightColor} setHighlightColor={setHighlightColor} data-id="element-209" />} data-id="element-208" />
      </Routes>
      <Navigation isScrolling={isScrolling} toggleScrolling={toggleScrolling} inSyncMode={true} data-id="element-210" />
    </div>;
};
export default DemoSyncModePage;